import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TypeCoordComponent } from './typeCoord/type-coord.component';
import { JoceComponent } from './joce/joce.component';
import { TypeAutresInfosATTRComponent } from './typeAutresInfosATTR/type-autres-infosATTR.component';
import { TypePersComponent } from './typePers/type-pers.component';
import { TypeAttributionMarcheLotComponent } from './typeAttributionMarcheLot/type-attribution-marche-lot.component';
import { TypeAdresseComponent } from './typeAdresse/type-adresse.component';
import { OffresComponent } from './offres/offres.component';
import { AttributionComponent } from './attribution/attribution.component';
import { TypeMontantComponent } from './typeMontant/type-montant.component';
import { MontantAnnuelComponent } from './montantAnnuel/montant-annuel.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { TypeAdresseCompleteMoraleComponent } from './typeAdresseCompleteMorale/type-adresse-complete-morale.component';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { DescriptionReduiteComponent } from './descriptionReduite/description-reduite.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeResultatAttributionComponent } from './typeResultatAttribution/type-resultat-attribution.component';
import { SousTraitanceOuiComponent } from './sousTraitanceOui/sous-traitance-oui.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormDiversAttributionComponent } from './formDiversAttribution/formDiversAttribution.component';
import { FormDiversCommonModule } from '../common/formdivers.module';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step5Component } from './steps/step5/step5.component';
import { Step6Component } from './steps/step6/step6.component';
import { LotMarcheComponent } from './lotMarche/lot-marche.component';

@NgModule({
  declarations: [
    TypeCoordComponent,
    JoceComponent,
    TypeAutresInfosATTRComponent,
    TypePersComponent,
    TypeAttributionMarcheLotComponent,
    TypeAdresseComponent,
    OffresComponent,
    AttributionComponent,
    TypeMontantComponent,
    MontantAnnuelComponent,
    AvisInitialTypeComponent,
    TypeAdresseCompleteMoraleComponent,
    TypeCPVClassComponent,
    DescriptionReduiteComponent,
    TypeObjCPVComponent,
    TypeVoieComponent,
    TypeResultatAttributionComponent,
    SousTraitanceOuiComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    LotMarcheComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step6Component,
    FormDiversAttributionComponent
  ],
  exports: [
    FormDiversAttributionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    FormDiversCommonModule
  ]
})
export class FormDiversAttributionModule {
}

